import React from "react"
import { ProductVariant } from "../../../../types/product"
import CustomSelect from "../../../../ui/atoms/CustomSelect"
import classes from "./ProductQuantityDropdown.module.css"

interface Props {
  variants: ProductVariant[]
  selectedVariant: ProductVariant
  onVariantSelect: (variant: ProductVariant) => void
  fullWidth?: boolean
}

const ProductQuantityDropdown = ({
  onVariantSelect,
  selectedVariant,
  variants,
  fullWidth,
}: Props) => {
  const handleVariantChange = (newVariantId: string) => {
    onVariantSelect(
      variants.find((x) => x.info.variantId === newVariantId) as ProductVariant
    )
  }

  return (
    <CustomSelect
      classes={{
        select: classes.select,
        panel: classes.selectPanel,
      }}
      fixed={variants.length <= 1}
      values={variants.map((variant) => ({
        id: variant.info.variantId,
        label: variant.info.quantity,
      }))}
      value={selectedVariant.info.variantId}
      onChange={handleVariantChange}
      size="small"
      variant="outlined"
      fullWidth={fullWidth}
    />
  )
}

export default ProductQuantityDropdown
